module.exports = __webpack_public_path__ + "img/9788954626460.889d89f4.jpg";